'use client';

import { useChain } from 'react-spring';

/** Härledd ur useChain självt, så typen följer biblioteket i stället för att gissa. */
type Kedjerefs = Parameters<typeof useChain>[0];

/**
 * Kedjar springs så att ordningen inte kan gå fel.
 *
 * Används där ordningen bär betydelse och inte bara ser trevlig ut: signatur fyra
 * får inte dyka upp före signatur tre, och bokföringsåret går inte baklänges.
 *
 * `tider` är normaliserade tidpunkter (0–1) med samma längd som `refs`.
 */
export function useSekvens(refs: Kedjerefs, tider: number[], aktiv: boolean): void {
    useChain(aktiv ? refs : [], tider);
}
